import { Todo, TodoCard } from "@/components/todo-card/TodoCard.tsx";
import { useCallback } from "react";

export interface TodoCardListProps {
  cards: Todo[];
  onUpdateCard?: (todo: Todo) => void;
  onDeleteClick?: (id: number) => void;
}

export function TodoCardList({
  cards,
  onUpdateCard,
  onDeleteClick,
}: TodoCardListProps) {
  const onCardCompleteChange = useCallback(
    (id: number, checked: boolean) => {
      const todo = cards.find((card) => card.id === id)!;
      onUpdateCard?.({
        ...todo,
        isComplete: checked,
      });
      console.log(id, checked);
    },
    [cards, onUpdateCard],
  );
  const deleteClickHandler = useCallback(
    (id: number) => {
      onDeleteClick?.(id);
    },
    [onDeleteClick],
  );

  return (
    <>
      {cards.map((card) => (
        <TodoCard
          key={card.id}
          {...card}
          onCompleteChange={onCardCompleteChange}
          onDeleteClick={deleteClickHandler}
        />
      ))}
    </>
  );
}
